import { createEffect } from "solid-js"
import { createStore, reconcile } from "solid-js/store"
import { createSimpleContext } from "@mux/ui/context"
import { createAccountPreference } from "@/context/account-preference"
import { readSmallModelRoutesSnapshot, seedSmallModelRoutesSnapshot } from "@/context/small-model-route-cache"
import { getSmallModelRoutes } from "@/transport/preferences"
import type { SmallModelRoute } from "@/utils/small-model-routes"

const preferencePath = "/api/ai/preferences/small_model_routes"

export const { use: useSmallModelRoutes, provider: SmallModelRoutesProvider } = createSimpleContext({
  name: "SmallModelRoutes",
  gate: false,
  init: () => {
    const initial = readSmallModelRoutesSnapshot() ?? []
    const [routes, setRoutes] = createStore<SmallModelRoute[]>(initial.map((route) => ({ ...route })))
    const preference = createAccountPreference<SmallModelRoute[]>(
      "small_model_routes", initial, () => getSmallModelRoutes(preferencePath),
    )
    createEffect(() => {
      const next = preference.value()
      setRoutes(reconcile(next.map((route) => ({ ...route }))))
      if (preference.ready() && !preference.saving()) seedSmallModelRoutesSnapshot(next)
    })

    return {
      routes,
      ready: preference.ready,
      saving: preference.saving,
      loadError: preference.error,
      refresh: preference.refresh,
      save: preference.save,
    }
  },
})
